import type { StartPeriod } from '../db/models'

/**
 * Die Uhrzeiten der **Zeiträume** am Wann und an der Deadline. Hier in `lib/`, weil außer dem
 * Wann-Wähler auch der Zeitplan der Erinnerungen sie braucht: Ein Zeitraum zählt dort mit
 * seinem Beginn (Plan task-reminders, Entscheidung 5).
 */
export const PERIOD_RANGES: Record<StartPeriod, { start: string; end: string }> = {
  morning: { start: '08:00', end: '12:00' },
  noon: { start: '12:00', end: '13:00' },
  afternoon: { start: '13:00', end: '17:00' },
  evening: { start: '17:00', end: '20:00' },
}
